"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficePim_de_de = void 0;
function backofficePim_de_de() {
    return {
        "backoffice.pim.title": "Produkte",
        "backoffice.pim.pricezones.edit": "Preiszone bearbeiten",
        "backoffice.pim.pricezones.add": "Preiszone hinzufügen",
        "backoffice.pim.pricezones.title": "Preiszonen",
        "backoffice.pim.pricezones.subtitle": "Preiszonen erlauben Ihnen, den Preis Ihrer Produkte in unterschiedlichen Währungen anzubieten.",
        "backoffice.pim.pricezones.tabheader": "Preiszonen",
        "backoffice.pim.pricezones.titleinput": "Titel",
        "backoffice.pim.pricezones.table.title": "Titel",
        "backoffice.pim.pricezones.table.currency": "Währung (ISO)",
        "backoffice.pim.pricezones.empty.headline": "Keine Preiszonen angelegt",
        "backoffice.pim.pricezones.empty.message": "Hier können Sie Ihre Preiszonen und Währungen pflegen. Leider gibt es noch keine Preiszonen.",
        "backoffice.pim.pricezones.empty.creationtitle": "Neue Preiszone anlegen",
        "backoffice.pim.pricezones.success.create": "Die Preiszone wurde erfolgreich hinzugefügt",
        "backoffice.pim.pricezones.success.update": "Die Preiszone wurde erfolgreich aktualisiert",
        "backoffice.pim.pricezones.success.delete": "Die Preiszone wure erfolgreich gelöscht",
        "backoffice.pim.pricezones.error.create": "Hinzufügen der Preiszone fehlgeschlagen",
        "backoffice.pim.pricezones.error.update": "Aktualisierung der Preiszone fehlgeschlagen",
        "backoffice.pim.pricezones.error.delete": "Löschen der Preiszone fehlgeschlagen",
        "backoffice.pim.pricezones.info.title": "ISO 4217 Definition",
        "backoffice.pim.pricezones.info.message": "ISO 4217 ist die von der Internationalen Organisation für Normung publizierte Norm für Währungs-Kurzzeichen, die im internationalen Zahlungsverkehr zur eindeutigen Identifizierung benutzt werden sollen. Die ISO-Abkürzungen umfassen jeweils drei Buchstaben. Die ersten beiden sind üblicherweise die Landeskennung (beispielsweise AU für Australien), der letzte Buchstabe ist in der Regel der Anfangsbuchstabe des Währungsnamens, beispielsweise D für Dollar. Beispiele: AUD = Australischer Dollar, EUR = Euro, USD = US-Dollar",
        "backoffice.pim.supplier.tabheader": "Zulieferer",
        "backoffice.pim.supplier.title": "Zulieferer",
        "backoffice.pim.supplier.subtitle": "Übersicht Ihrer Zulieferer.",
        "backoffice.pim.supplier.table.title": "Titel",
        "backoffice.pim.supplier.table.code": "Code",
        "backoffice.pim.supplier.table.orderplacementserviceurl": "Bestellplatzierungsservice-URL",
        "backoffice.pim.supplier.empty.headline": "Keine Zulieferer angelegt",
        "backoffice.pim.supplier.empty.message": "Zulieferer anlegen...",
        "backoffice.pim.supplier.editor.add": "Zulieferer hinzufügen",
        "backoffice.pim.supplier.editor.edit": "Zulieferer bearbeiten",
        "backoffice.pim.supplier.editor.title": "Zulieferername",
        "backoffice.pim.supplier.editor.code": "Zulieferer Code",
        "backoffice.pim.supplier.editor.customfields": "Benutzerdefinierte Felder",
        "backoffice.pim.supplier.editor.field": "Feld",
        "backoffice.pim.supplier.editor.value": "Wert",
        "backoffice.pim.supplier.editor.orderplacementserviceurl": "Bestellplatzierungsservice-URL",
        "backoffice.pim.supplier.editor.orderplacementserviceauthheader": "Authentifizierungsheader für Bestellplatzierungsservice",
        "backoffice.pim.products.tabheader": "Produkte",
        "backoffice.pim.products.title": "Produktübersicht",
        "backoffice.pim.products.add": "Produkt hinzufügen",
        "backoffice.pim.products.empty.headline": "Kein Produkte gefunden",
        "backoffice.pim.products.empty.message": "Hier können Sie neue Produkte anlegen!",
        "backoffice.pim.products.duplicate.title": "Produkt duplizieren",
        "backoffice.pim.products.duplicate.message": "Möchten Sie dieses Produkt wirklich duplizieren?",
        "backoffice.pim.products.images.empty.headline": "Kein Produktbilder gefunden",
        "backoffice.pim.products.images.empty.message": "Hier können Sie neue Produktbilder hinzufügen",
        "backoffice.pim.products.draft.active": "aktiv",
        "backoffice.pim.products.draft.inactive": "inaktiv",
        "backoffice.pim.products.draft.title": "Titel",
        "backoffice.pim.products.draft.shorttitle": "Kurztitel",
        "backoffice.pim.products.draft.description": "Beschreibung",
        "backoffice.pim.products.draft.shortdescription": "Kurzbeschreibung",
        "backoffice.pim.products.draft.pricezones.none": "Sie haben noch keine Preiszone angelegt",
        "backoffice.pim.products.draft.pricezones.create": "Preiszone anlegen",
        "backoffice.pim.products.draft.header.title": "Produkteditor",
        "backoffice.pim.products.draft.header.edit": "Produktdetails editieren",
        "backoffice.pim.products.draft.header.create": "Lege ein neues Produkt an",
        "backoffice.pim.products.draft.tags": "Tags",
        "backoffice.pim.products.draft.tagsdescription": "Tags können zum sortieren, filtern oder gruppieren der Produkte verwendet werden",
        "backoffice.pim.products.draft.edit": "Produkt editieren",
        "backoffice.pim.products.draft.edithint": "Hier können Sie das Produkt editieren...",
        "backoffice.pim.products.draft.all": "Alle Produkte",
        "backoffice.pim.products.draft.add": "Produkt hinzufügen",
        "backoffice.pim.products.draft.addimage": "Produktbild hinzufügen",
        "backoffice.pim.products.draft.addhint": "Hier können Sie ein neues Produkt anlegen",
        "backoffice.pim.products.draft.basicinfo": "Basis Informationen",
        "backoffice.pim.products.draft.prices": "Preise",
        "backoffice.pim.products.draft.pricehint": "Legen Sie den Preis des Produkts für eine bestimmte Preiszone fest",
        "backoffice.pim.products.draft.save.success": "Die Produkte wurden erfolgreich aktualisiert",
        "backoffice.pim.products.draft.save.error": "Die Produkte konnten nicht aktualisiert werden",
        "backoffice.pim.products.draft.supplier.title": "Produktspezifische Zuliefererdetails",
        "backoffice.pim.products.draft.supplier.selectsupplier": "Zulieferer auswählen",
        "backoffice.pim.products.draft.supplier.selectnone": "Kein Zulieferer",
        "backoffice.pim.products.draft.supplier.articleidentifier": "Zuliefererspezifische Artikelnummer (optional)",
        "backoffice.pim.products.draft.supplier.description": "Hier können Sie einen Zulieferer auswählen und ggfs. eine Artikelnummer hinterlegen.",
        "backoffice.pim.products.draft.metadata.label": "Projektspezifische Daten",
        "backoffice.pim.products.draft.metadata.description": "Hier können Sie projektspezifische Daten an deinen Produkten speichern.",
        "backoffice.pim.products.product.basicinfo": "Produktinfos",
        "backoffice.pim.products.product.options": "Produktoptionen",
        "backoffice.pim.products.product.variants": "Produktvarianten",
        "backoffice.pim.products.product.images": "Produktbilder",
        "backoffice.pim.products.delete.success": "Das Produkt wurde erfolgreich entfernt",
        "backoffice.pim.products.table.image": "Produktbild",
        "backoffice.pim.products.table.title": "Titel",
        "backoffice.pim.products.table.active": "Aktiv",
        "backoffice.pim.products.table.createdat": "Erstellt am",
        "backoffice.pim.products.table.tags": "Tags",
        "backoffice.pim.products.table.options": "Produktoptionen",
        "backoffice.pim.products.table.prices": "Preise",
        "backoffice.pim.products.oms.workflows.events.placed.label": "Bestellung aufgegeben",
        "backoffice.pim.products.oms.workflows.events.placed.description": "Wird gefeuert, sobald eine neue Bestellung eingegangen ist.",
        "backoffice.pim.oms.title": "Bestellungen",
        "backoffice.pim.oms.subtitle": "Eine Übersicht über die Bestellungen Ihrer Kunden.",
        "backoffice.pim.oms.orders.table.orderdate": "Bestelldatum",
        "backoffice.pim.oms.orders.table.user": "Benutzer",
        "backoffice.pim.oms.orders.table.company": "Firma",
        "backoffice.pim.oms.orders.table.orderpositions": "Bestellpositionen",
        "backoffice.pim.oms.orders.table.deliveryaddress": "Versandadresse",
        "backoffice.pim.oms.orders.table.supplier": "Zulieferer",
        "backoffice.pim.oms.orders.table.status": "Status",
        "backoffice.pim.oms.orders.table.statushistory": "Statusverlauf",
        "backoffice.pim.oms.orders.empty.headline": "Keine Bestellungen gefunden",
        "backoffice.pim.oms.orders.empty.message": "Wie es scheint, sind noch keine Bestellungen eingegangen. Bringen Sie Ihre Kunden dazu, Ihre Produkte zu kaufen, dann können Sie hier die Bestellungen sehen."
    };
}
exports.backofficePim_de_de = backofficePim_de_de;
